module.exports = __webpack_public_path__ + "img/hero.2afea7b4.png";